import { createContext, useContext } from 'react';
import { CSSDOMRenderer } from './_css_dom_renderer';

export const LayoutContext = createContext<CSSDOMRenderer>(undefined as unknown as CSSDOMRenderer);

export function useLayoutContext(): CSSDOMRenderer {
	const layoutContext = useContext(LayoutContext);
	if (layoutContext === undefined) {
		throw new Error('useLayoutContext must be used within a LayoutProvider');
	}

	return layoutContext;
}
